module.exports = __webpack_public_path__ + "assets/54a08abd80fc1370ea019b2e3137c7e7.mp4";